import * as React from 'react';
import { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import CalendarFormIcon from '../../../assets/icons/CalendarFormIcon';

const Calendar = ({
    label = '',
    defaultValue,
    required = true,
    handleChange = (date: Dayjs | null | string) => {},
    disabled = false,
    error = false
}: any) => {
    const [value, setValue] = React.useState<Dayjs | null | string>(null);
    React.useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue);
        }
    }, [defaultValue]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
                component={'span'}
                sx={{
                    position: 'relative',
                    '.MuiInputBase-root': {
                        flexDirection: 'row-reverse'
                    }
                }}
            >
                <InputLabel
                    sx={{
                        color: error ? 'red' : '#ADAAAA',
                        fontSize: { sm: '14px', xs: '12px' },
                        position: 'absolute',
                        top: '8px',
                        left: '72px',
                        zIndex: 1,
                        fontFamily: 'Open Sans'
                    }}
                    required
                >
                    {label}
                </InputLabel>
                <DatePicker
                    views={['year']}
                    disabled={disabled}
                    value={value}
                    onChange={(newValue) => {
                        setValue(newValue);
                        handleChange(newValue);
                    }}
                    components={{
                        OpenPickerIcon: CalendarFormIcon
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            variant="filled"
                            sx={{
                                '& 	.MuiInputBase-input': {
                                    ml: '10px',
                                    position: 'relative'
                                },
                                '& .MuiInputBase-root::before': {
                                    borderBottom: 0
                                },
                                '& .MuiInputBase-root::after': {
                                    borderBottom: 0
                                },
                                '& .MuiInputBase-root': {
                                    backgroundColor: '#FCFBF8',
                                    width: '100%',
                                    height: { sm: '70px', xs: '60px' },
                                    fontFamily: 'open sans',
                                    color: '#23282B',
                                    borderBottom: '1px solid #D9D9D9'
                                },
                                '& .MuiPickersDay-root.Mui-selected': {
                                    backgroundColor: '#494949'
                                },
                                '& .MuiPickersDay-root.Mui-selected:hover': {
                                    backgroundColor: '#494949'
                                }
                            }}
                        />
                    )}
                />
            </Box>
        </LocalizationProvider>
    );
};

export default Calendar;
